<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Fields</span>
      </v-card-title>

      <v-card-text class="resizable-card__body">
        <v-text-field
            disabled
            label="UID:"
            v-model.trim="model.uid"
            hide-details
            outlined
            dense
        />

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-level-track-level-field-tiles-panel
                :model.sync="model.tiles"
                title="Tiles"
            />
            <r-level-track-level-pattern-panel
                :items.sync="model.pattern"
                title="Pattern"
            />
          </v-expansion-panels>
        </v-row>
      </v-card-text>

      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>

      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import { ViewRules } from "@/common/ViewRules";

import RLevelTrackLevelPatternPanel from "@/modules/redactor/views/level-track/level/pattern/r-level-track-level-pattern-panel.vue";
import RLevelTrackLevelFieldTilesPanel from "@/modules/redactor/views/level-track/level/field/tiles/r-level-track-level-field-tiles-panel.vue";

import { LevelTrackLevelField } from "@/modules/redactor/models/level-track/LevelTrackLevelField";

export default {
  name: "r-level-track-level-field-dialog",
  components: {
    RLevelTrackLevelPatternPanel,
    RLevelTrackLevelFieldTilesPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(LevelTrackLevelField),
    rules: ViewRules.READONLY,

    dialogWidth: 805,
    dialogHeight: 585,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 805,
    resizeStartHeight: 585,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new LevelTrackLevelField();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve && this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject && this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },

    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;

      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;

      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;

      const minWidth = 500;
      const minHeight = 350;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;

      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resizable-card__body {
  flex: 1;
  overflow: auto;
}

.resizable-card__actions {
  flex-shrink: 0;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>